import * as React from "react";
const SvgIconRadio = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 8.33, stroke: "currentColor", strokeWidth: 1.67 }));
export default SvgIconRadio;
